module.exports = __webpack_public_path__ + "img/video.d25348f3.png";